/* ThawLab Aurora — theme.js */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    if (format.indexOf('amount_no_decimals') !== -1) value = Math.round(cents / 100).toString();
    return format.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  /* ---------- header scroll state ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mobile menu ---------- */
  var mobileMenu = document.getElementById('MobileMenu');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) {
      mobileMenu && mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    if (e.target.closest('[data-menu-close]') || e.target.classList.contains('mobile-menu__overlay')) {
      mobileMenu && mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-inview'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-inview'); });
  }

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function renderShipBar(totalCents) {
    var bar = document.getElementById('DrawerShipBar');
    if (!bar) return;
    var threshold = parseFloat(bar.dataset.threshold);
    if (!threshold || isNaN(threshold)) { bar.innerHTML = ''; return; }
    var thresholdCents = threshold * 100;
    var pct = Math.min(100, (totalCents / thresholdCents) * 100);
    var remaining = thresholdCents - totalCents;
    var msg = remaining > 0
      ? 'You are <strong>' + formatMoney(remaining) + '</strong> away from free shipping'
      : 'You’ve unlocked <strong>free shipping</strong>';
    bar.innerHTML =
      '<div class="shipbar' + (remaining <= 0 ? ' shipbar--done' : '') + '">' +
      '<span>' + msg + '</span>' +
      '<div class="shipbar__track"><div class="shipbar__fill" style="width:' + pct + '%"></div></div>' +
      '</div>';
  }

  function renderDrawer(cart) {
    var body = document.getElementById('DrawerBody');
    var foot = document.getElementById('DrawerFoot');
    if (!body) return;
    updateCartCount(cart.item_count);
    renderShipBar(cart.total_price);

    if (!cart.items.length) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (item, i) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') + '" alt="" loading="lazy">'
        : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="drawer-line__variant">' + item.variant_title + '</div>' : '';
      return (
        '<div class="drawer-line" data-line="' + (i + 1) + '">' +
        '<div class="drawer-line__img">' + img + '</div>' +
        '<div>' +
        '<div class="drawer-line__title">' + item.product_title + '</div>' + variant +
        '<div class="drawer-line__qty">' +
        '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">&minus;</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
        '</div>' +
        '</div>' +
        '<div class="drawer-line__price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>'
      );
    }).join('');
    if (foot) {
      foot.hidden = false;
      var st = document.getElementById('DrawerSubtotal');
      if (st) st.textContent = formatMoney(cart.total_price);
    }
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function refreshDrawer() {
    return fetchCart().then(renderDrawer);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      refreshDrawer().then(openDrawer);
    }
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var line = qtyBtn.closest('.drawer-line');
      var qtyEl = line.querySelector('.drawer-line__qty span');
      var newQty = Math.max(0, parseInt(qtyEl.textContent, 10) + parseInt(qtyBtn.dataset.qtyChange, 10));
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line.dataset.line, 10), quantity: newQty })
      }).then(function (r) { return r.json(); }).then(renderDrawer);
    }
  });

  var checkoutBtn = document.getElementById('DrawerCheckout');
  if (checkoutBtn) checkoutBtn.addEventListener('click', function () { window.location.href = '/checkout'; });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- AJAX add to cart (product forms + quick add) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Could not add to cart'); });
        return r.json();
      })
      .then(function () {
        if (window.theme && window.theme.cartDrawer === false) {
          window.location.href = (window.theme.routes && window.theme.routes.cart) || '/cart';
          return;
        }
        return refreshDrawer().then(openDrawer);
      })
      .catch(function (err) {
        alert(err.message);
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
      });
  });

  /* ---------- product page: variants, gallery, sticky ATC ---------- */
  document.querySelectorAll('[data-product-wrapper]').forEach(function (wrapper) {
    var jsonEl = wrapper.querySelector('[data-variants-json]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var selects = wrapper.querySelectorAll('[data-option-select]');
    var idInput = wrapper.querySelector('input[name="id"]');
    var priceEl = wrapper.querySelector('[data-price]');
    var compareEl = wrapper.querySelector('[data-compare-price]');
    var saveEl = wrapper.querySelector('[data-save-badge]');
    var atcBtn = wrapper.querySelector('[data-atc-button]');

    function currentVariant() {
      var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function onVariantChange() {
      var v = currentVariant();
      if (!v) {
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.hidden = false;
          if (saveEl) {
            saveEl.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
            saveEl.hidden = false;
          }
        } else {
          compareEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
      }
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        atcBtn.textContent = v.available ? (atcBtn.dataset.label || 'Add to cart') : 'Sold out';
      }
      if (v.featured_media && v.featured_media.id) {
        var thumb = wrapper.querySelector('.product-gallery__thumb[data-media-id="' + v.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', onVariantChange); });

    /* gallery */
    var mainImg = wrapper.querySelector('[data-main-image]');
    wrapper.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg && thumb.dataset.src) {
          mainImg.src = thumb.dataset.src;
          if (thumb.dataset.srcset) mainImg.srcset = thumb.dataset.srcset;
        }
        wrapper.querySelectorAll('.product-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* qty stepper */
    wrapper.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = wrapper.querySelector('.qty-input input');
        input.value = Math.max(1, parseInt(input.value || '1', 10) + parseInt(b.dataset.qtyStep, 10));
      });
    });

    /* sticky mobile ATC */
    var sticky = document.getElementById('StickyAtc');
    var buyRow = wrapper.querySelector('.buy-row');
    if (sticky && buyRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '-80px 0px 0px 0px' }).observe(buyRow);
      var stickyBtn = sticky.querySelector('button');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        var form = wrapper.querySelector('form[data-ajax-cart]');
        if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
  });

  /* ---------- collection sort ---------- */
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
})();
